import * as tokens from '@utmost.co/utmost-design-tokens';
import { Components } from '../../../styles';
import { inputBaseRootStyle } from './input';

const INPUT_MIN_HEIGHT = 'var(--select-input-min-height-md, 40px)';

export const selectTheme = {
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '&[data-version="current"]': {
          color: 'unset',
          border: 'unset',
          backgroundColor: 'unset',
          transition: 'all 0.15s ease-in-out',
          minHeight: `var(--select-min-height, 36x)`,
          padding: 0,
          paddingTop: 2,
          '&:focus-within': {
            background: 'transparent',
            borderColor: tokens.colorPrimary
          },
          '.Mui-disabled.MuiInputBase-root': {
            borderStyle: 'dotted',
            color: 'rgba(0, 0, 0, 0.38)'
          },
          '.MuiFormLabel-root + &': {
            marginTop: 4
          },
          '&.single-select [data-test="selected-value"] + .MuiInputBase-input': {
            minWidth: 10
          }
        }
      },
      option: {
        color: tokens.colorOnSurface,
        margin: 0,
        minHeight: '41px !important',
        '&[aria-selected="true"]': {
          backgroundColor: '#e4f6ff' // new colorSecondaryContainer
        },
        '&:hover, &.Mui-focused': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      },
      inputRoot: {
        ...inputBaseRootStyle,
        minHeight: INPUT_MIN_HEIGHT,
        marginTop: 0,
        position: 'relative',
        paddingLeft: 8,
        '& .MuiAutocomplete-input': {
          minWidth: 120
        }
      },
      listbox: {
        paddingBottom: 0
      },
      paper: {
        '.virtual-item +.virtual-item .extra-option, .MuiList-root': {
          borderTop: `1px solid ${tokens.colorSurfaceVariant}`
        }
      },
      popupIndicator: {
        '&.MuiButtonBase-root': {
          padding: 0
        }
      }
    }
  }
} satisfies Components;
